<div class="dialog-container">
    <div>
        <mat-toolbar class="w-100 clr" fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="10px">
            <div class="pad10">
                <h3>Approve Bulk Property</h3>
            </div>
        </mat-toolbar>
        <ngx-loading [show]="loader" [config]="{backdropBackgroundColour: 'rgba(255,255,255,0.3)'}">
        </ngx-loading>
        <div>
            <div class="margt">
                <mat-radio-group [(ngModel)]="action">
                    <mat-radio-button class="radio_text align" *ngFor="let option of option_secondary" [value]="option.value" [disabled]="disableOption(option.value)">
                        <span class="fnt-md inline">
                  {{option.label}}
                </span>
                    </mat-radio-button>
                </mat-radio-group>
            </div>
            <div class="bg2" *ngIf="action == 3 || action == 8 || action ==11">
                <div class="pad10">
                    <mat-form-field floatLabel="never" class="w-100 bg2">
                        <textarea class="resnone" [(ngModel)]="user_comment" matInput placeholder="Type comment here..." rows="3"></textarea>
                    </mat-form-field>
                </div>
            </div>
            <div class="cent1 mt" *ngIf="action == 4">
                <div class="grid50ph">
                    <span class="fntM">Assign to user:</span>
                    <mat-select (selectionChange)="assign_user($event)" [(value)]="selected_user_id" class="form-select-l nw1">
                        <ng-container *ngFor="let user of user_list">
                            <mat-option *ngIf="user.id != 0" [value]="user.id">{{user.username}}</mat-option>
                        </ng-container>
                    </mat-select>
                </div>
            </div>
            <div class="margt bg1">
                <mat-radio-group [(ngModel)]="action">
                    <mat-radio-button class="radio_text align" *ngFor="let option of option_primary" [value]="option.value" [disabled]="selectedFilter == 3">
                        <span class="fnt-md">
                  {{option.label}}
                </span>
                    </mat-radio-button>
                </mat-radio-group>
            </div>
        </div>

    </div>
    <div class="h50">
        <div class="ml10 grid50ph-nogap">
            <button mat-button type="submit" (click)="openConfirmation()" class="orange-button w-100 br0" [disabled]="!action">{{button}}</button>
            <button mat-button type="button" (click)="closeDialog()" class="grey-button w-100 br0">Cancel</button>
        </div>
    </div>
</div>
